import { http } from "./api";

let host = null;
let banHost = null;
export const registerComplianceHost = (fn) => { host = fn; };
export const registerBanHost = (fn) => { banHost = fn; };

const fail = (msg, extra) => Object.assign(new Error(msg), extra);

export async function vacationCall(method, url, body) {
  const params = {};
  for (;;) {
    try {
      return await http[method](url, body, { params });
    } catch (e) {
      const d = e?.response?.data?.detail;
      if (e?.response?.status !== 409) throw e;
      if (d?.code === "site_ban" && banHost) {
        const choice = await new Promise((resolve) => banHost({ ...d, resolve }));
        if (!choice) throw fail("Opération annulée", { cancelled: true });
        Object.assign(params, { force_ban: true, ban_reason: choice.reason });
        continue;
      }
      if (d?.code !== "compliance" || !host) throw e;
      const choice = await new Promise((resolve) => host({ ...d, resolve }));
      if (!choice) throw fail("Opération annulée", { cancelled: true });
      if (choice.action === "override") { Object.assign(params, { force: true, reason: choice.reason }); continue; }
      const kind = method === "post" ? "create" : "update";
      await http.post("/compliance/requests", { kind, vacation_id: kind === "update" ? url.split("/").pop() : null, payload: body, reason: choice.reason });
      throw fail("Demande de validation envoyée à l'administrateur principal.", { requested: true });
    }
  }
}
